// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--1c9am","footerContainer":"Footer-module--footer-container--amYl8","logo":"Footer-module--logo--3Uan7"};